import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { EnvRoleService } from '../services/env-role.service';

/**
 * adminGuard - restricts route access to ADMIN IAG roles only
 * (SG-IC1-NONPROD-ADMIN-ROLE / SG-IC1-PROD-ADMIN-ROLE).
 * Redirects unauthenticated or unauthorized users to /access-denied.
 */
export const adminGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const envRoleService = inject(EnvRoleService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    await router.navigate(['/access-denied']);
    return false;
  }

  if (!envRoleService.isAdmin()) {
    await router.navigate(['/access-denied']);
    return false;
  }

  return true;
};
